module.exports = __webpack_public_path__ + "img/success-icon.e06c74fe.svg";